import React, { useEffect, useState } from "react";
import {
  Button,
  Chip,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles,
} from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { useHistory, useParams } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import NewTicketModal from "../../components/NewTicketModal";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  paper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
}));

const sourceLabel = (source) => {
  if (!Array.isArray(source)) return "-";
  if (source.includes("organization") && source.includes("group")) return "Organizacao e Grupo";
  if (source.includes("organization")) return "Organizacao";
  if (source.includes("group")) return "Grupo";
  return "-";
};

const OrganizationContacts = () => {
  const classes = useStyles();
  const history = useHistory();
  const { organizationId } = useParams();
  const [payload, setPayload] = useState(null);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket && ticket.uuid) {
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const loadContacts = async () => {
    try {
      const { data } = await api.get(`/organizations/${organizationId}/contacts`);
      setPayload(data);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    loadContacts();
  }, [organizationId]);

  const contacts = payload?.contacts || [];
  const organization = payload?.organization;

  return (
    <MainContainer>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={handleCloseOrOpenTicket}
      />

      <MainHeader>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <Button startIcon={<ArrowBackIcon />} onClick={() => history.push("/organizations")}>Voltar</Button>
            <Title>Contatos da Organizacao</Title>
            <Typography variant="body2" color="textSecondary">
              {organization
                ? `${organization.razaoSocial || organization.nomeFantasia} - ${organization.cnpj || ""}`
                : `Organizacao ${organizationId}`}
            </Typography>
          </Grid>
        </Grid>
      </MainHeader>

      <Paper className={classes.paper} variant="outlined">
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Contato</TableCell>
              <TableCell>Numero</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Origem do Vinculo</TableCell>
              <TableCell>Setor</TableCell>
              <TableCell>Papel na Organizacao</TableCell>
              <TableCell>Papel no Grupo</TableCell>
              <TableCell align="center">Conversa</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.length === 0 && (
              <TableRow>
                <TableCell colSpan={8}>
                  <Typography variant="body2" color="textSecondary">
                    Nenhum contato vinculado para esta organizacao.
                  </Typography>
                </TableCell>
              </TableRow>
            )}

            {contacts.map((item) => (
              <TableRow key={`${item.contact?.id || "contact"}-${item.sector?.id || "no-sector"}`}>
                <TableCell>{item.contact?.name || "-"}</TableCell>
                <TableCell>{item.contact?.number || "-"}</TableCell>
                <TableCell>{item.contact?.email || "-"}</TableCell>
                <TableCell>
                  <Chip size="small" label={sourceLabel(item.source)} color="primary" />
                </TableCell>
                <TableCell>{item.sector?.name || "-"}</TableCell>
                <TableCell>{item.organizationRoleTitle || "-"}</TableCell>
                <TableCell>{item.groupRoleTitle || "-"}</TableCell>
                <TableCell align="center">
                  <IconButton
                    size="small"
                    disabled={!item.contact?.id}
                    onClick={() => {
                      if (!item.contact?.id) return;
                      setContactTicket({
                        ...item.contact,
                        channel: item.contact?.channel || "whatsapp",
                      });
                      setNewTicketModalOpen(true);
                    }}
                  >
                    <WhatsAppIcon style={{ color: "green" }} fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </MainContainer>
  );
};

export default OrganizationContacts;